export default "\n.visit-container{\n  cursor: pointer;\n}\n";